import { useState, useCallback } from 'react';
import { getESMExitedStocks } from '@/lib/api/esmExitedStocksApi';
import { ESMExitedStockItem } from '@/types/esmExitedStocks';

export function useESMExitedStocks() {
  const [allStocks, setAllStocks] = useState<ESMExitedStockItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchESMExitedStocks = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getESMExitedStocks(filters);
      setAllStocks(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load ESM exited stocks. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    stocks: allStocks,
    loading,
    error,
    fetchESMExitedStocks,
  };
}
